import { getByPartitionKey } from "../services/api-service";
import { TableName } from "../../constants/table";
import { useQuery } from "@tanstack/react-query";
import { deleteEntity, getAllEntities } from "../services/api-service";
import { IManageTenant } from "../../models/managetenant";
import { ITenant } from "../../models/tenant";

const tableName = TableName.Tenant;

export const fetchTenants = async (): Promise<{ id: string }[]> => {
  const tenants = await getAllEntities(tableName) as ITenant[];
  return tenants.map((tenant) => ({
    ...tenant,
    id: tenant.RowKey,
  }));
};

export const useGetTenants = () =>
  useQuery({
    queryKey: ["fetchTenants"],
    queryFn: async () => fetchTenants(),
  });

export const deleteTenant = async (payload: {
  PartitionKey: string;
  RowKey: string;
}) => {
  const { PartitionKey, RowKey } = payload;
  await deleteEntity(tableName, PartitionKey, RowKey);
};

export const getLatestCompanyLimit = async (tenantId: string) => {
  const tenant: IManageTenant[] = await getByPartitionKey(tableName, tenantId);
  return tenant.length > 0 ? tenant[0]?.CompanyLicenses : 0;
};
